import React, { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";

interface ICertification {
    id: number;
    title: string;
    line: string;
    alt: string;
    logo: string;
    thumbnail: string;
    originalimg: string;
    is_active: boolean;
}


const Certification: React.FC = () => {
    const [certifications, setCertification] = useState<ICertification[]>([]);

    useEffect(() => {
        const fetchCertifications = async () => {
            try {
                const res = await axiosInstance.get("/api/openRoute/certification");
                if (Array.isArray(res.data.certification)) {
                    setCertification(res.data.certification);
                } else {
                    console.warn("Unexpected response:", res.data);
                    setCertification([]); // fallback to empty array
                }
            } catch (error) {
                console.error("Error fetching certifications:", error);
            }
        };

        fetchCertifications();
    }, []);

    return (
        <>
            {certifications.length > 0 && (
                <div
                    className="bg-white rounded-3 p-0 layout-border mt-4 "
                    style={{ maxWidth: "425px", margin: "0 auto" }}
                >
                    <div className="d-flex align-items-center mb-3 font-16 ff-bold px-3 py-2 bg-2">
                        <span className="me-2">
                            <img
                                src="https://goodhand.b-cdn.net/Assets/Upload/certific.svg"
                                alt=""
                            />
                        </span>{" "}
                        Certified for Excellence
                    </div>
                    <div className="px-4 pb-4 text-black-50">
                        <div className="row">
                            {certifications.map(
                                (certificate: any, index: number) => (
                                    <div
                                        className="col-4"
                                        key={`certificate-${index}`}
                                    >
                                        <img
                                            src={certificate.logo}
                                            alt={certificate.title}
                                            className="img-fluid"
                                            style={{ height: "70px" }}
                                        />
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Certification;
